import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6a398dc1")
const _hoisted_1 = { class: "button-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("0")
const _hoisted_3 = { class: "button-text" }
const _hoisted_4 = { class: "button-text" }
const _hoisted_5 = { class: "button-text" }
const _hoisted_6 = { class: "button-text" }
const _hoisted_7 = { class: "button-text" }
const _hoisted_8 = { class: "button-text" }
const _hoisted_9 = { class: "button-text" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('menu.title')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, { onClick: $options.dismiss }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      size: "large",
                      name: "chevron-down-outline"
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            color: "secondary",
            disabled: !_ctx.notificationState,
            onClick: $options.showOptions
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                size: "large",
                name: "cloud-download-outline"
              }),
              _createVNode(_component_ion_badge, {
                mode: "ios",
                color: "warning",
                class: _normalizeClass(["notification", {showNotification:_ctx.notificationState}]),
                modelValue: _ctx.notificationState,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.notificationState = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["modelValue", "class"]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('menu.content.title')), 1),
              _createVNode(_component_ion_icon, {
                slot: "end",
                size: "large",
                name: "chevron-forward"
              })
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            color: "secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.pushPage('lang'))),
            id: "push-nav-child"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                size: "large",
                name: "language"
              }),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('menu.lang.title')), 1),
              _createVNode(_component_ion_icon, {
                slot: "end",
                size: "large",
                name: "chevron-forward"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            color: "secondary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.pushPage('help')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                size: "large",
                name: "help-circle-outline"
              }),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("menu.help")), 1),
              _createVNode(_component_ion_icon, {
                slot: "end",
                size: "large",
                name: "chevron-forward"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            color: "secondary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.pushPage('copy')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                size: "large",
                name: "information-circle-outline"
              }),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("menu.copyright")), 1),
              _createVNode(_component_ion_icon, {
                slot: "end",
                size: "large",
                name: "chevron-forward"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            color: "secondary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.pushPage('privacy')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                size: "large",
                name: "glasses"
              }),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("menu.privacy")), 1),
              _createVNode(_component_ion_icon, {
                slot: "end",
                size: "large",
                name: "chevron-forward"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            color: "secondary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.pushPage('terms')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                size: "large",
                name: "shield-checkmark-outline"
              }),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("menu.termini")), 1),
              _createVNode(_component_ion_icon, {
                slot: "end",
                size: "large",
                name: "chevron-forward"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_button, {
            expand: "block",
            size: "large",
            color: "secondary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.pushPage('test')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                size: "large",
                name: "checkmark-circle-outline"
              }),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("menu.test.title")), 1),
              _createVNode(_component_ion_icon, {
                slot: "end",
                size: "large",
                name: "chevron-forward"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "powered",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($options.openWebSite && $options.openWebSite(...args)))
        }, "Powered by Engineering Associates")
      ]),
      _: 1
    })
  ], 64))
}